import React from "react";

const StopRepossessionsGuide = () => {
  return <div>StopRepossessionsGuide</div>;
};

export default StopRepossessionsGuide;
